import React from 'react';
import { ModalButtons } from './styled';
import { Cross, Tick } from '../../helpers/icon-dictionary';
import Button from '../button';

export const modalButtons = (
    closeAlertModal,
    setCourseCreatorAsClean,
    handleOnback
) => (<ModalButtons>
    <Button
        circle
        handleOnClick={closeAlertModal}
        icon={Cross}
        warning />
    <Button
        circle
        handleOnClick={() => {
            setCourseCreatorAsClean();
            handleOnback();
        }}
        icon={Tick}
        success />
</ModalButtons>);

export const publishModalButtons = (showPublishModal, publishCourse) => (<ModalButtons>
    <Button
        circle
        className={'publish'}
        handleOnClick={() => showPublishModal(false)}
        label={'Take me back to edit'}
        warning />
    <Button
        circle
        className={'publish'}
        handleOnClick={publishCourse}
        label={'I understand - continue'}
        success />
</ModalButtons>);



// WEBPACK FOOTER //
// ./app/components/course-creator/modal-buttons.js